import React from 'react';
import { useLocale } from '../i18n/LocaleContext';

const STEPS = [
  { n: '01', h: 'how.1.h', p: 'how.1.p' },
  { n: '02', h: 'how.2.h', p: 'how.2.p' },
  { n: '03', h: 'how.3.h', p: 'how.3.p' },
];

export const HowItWorks = (): React.JSX.Element => {
  const { t } = useLocale();

  return (
    <section className="how" id="how">
      <div className="wrap">
        <div style={{ maxWidth: 720 }}>
          <span className="eyebrow">{t('how.eyebrow')}</span>
          <h2 style={{ marginTop: 12 }}>{t('how.h2')}</h2>
        </div>
        <div className="how-grid">
          {STEPS.map((s) => (
            <div key={s.n} className="step">
              <div className="big">{s.n}</div>
              <h3>{t(s.h)}</h3>
              <p>{t(s.p)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
